// Vendor Components
import React from 'react';

import Icon from '../components-core/icon';

// Styles
import './no-match.scss';

const NoMatch = () => (
    <section className="no-match">
        <h2>The requested page could not be found</h2>
        <div className="no-match--background">
            <Icon className="no-match--background-cloud" fontAwesomeType="cloud" />
            <Icon className="no-match--background-cloud" fontAwesomeType="cloud" />
        </div>
    </section>
);
export default NoMatch;
